import { render } from "./ItemDateTimePicker.vue?vue&type=template&id=3b3257a7"
import script from "./ItemDateTimePicker.vue?vue&type=script&lang=js"
export * from "./ItemDateTimePicker.vue?vue&type=script&lang=js"
script.render = render

export default script